import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import { useClientSelection } from "../client-context";
import { serviceForPage } from "../services";
import { tierLabel, tierLeavesOut } from "../tiers";
import { EmptyState, PageHeader } from "./Ui";

/**
 * A client page the selected client's tier leaves out, or whose service is switched
 * off for them, shows a notice instead (a link can still reach it).
 */
export default function TierGate({ path, title, children }: { path: string; title: string; children: ReactNode }) {
  const { client } = useClientSelection();
  if (!client) return <>{children}</>;
  const service = serviceForPage(client.services_off, path);
  if (service)
    return (
      <>
        <PageHeader eyebrow={client.name} title={title} />
        <EmptyState
          title={`${service} is switched off for ${client.name}`}
          description="Turn it back on in Setup, Portal, under Services we run."
          action={<Link className="button secondary" to={`/client-settings?client_id=${client.id}&view=tools`}>Open Services</Link>}
        />
      </>
    );
  if (!tierLeavesOut(client.service_tier, path)) return <>{children}</>;
  return (
    <>
      <PageHeader eyebrow={client.name} title={title} />
      <EmptyState
        title={`Not in ${client.name}'s plan`}
        description={`${client.name} is on ${tierLabel(client.service_tier)}, which covers tracking, conversions, ad spend, calls and reports. Change the service tier on the client's profile to use this page.`}
        action={<Link className="button secondary" to={`/clients/${client.id}`}>Open profile</Link>}
      />
    </>
  );
}
